import { ref, type ComputedRef } from 'vue';
import type { Sort } from '@shopware-pwa/types';

type SortingOption = { key: string; label: string };

const normalizeSortingOption = (
  sortingOrder: Sort | SortingOption,
): SortingOption => ({
  key: sortingOrder.key,
  label: sortingOrder.label,
});

// Global cache (shared across components)
let initialized = false;
const cachedSortingOptions = ref<SortingOption[]>([]);
const cachedSortingValue = ref<string>('');

export const useListingSorting = () => {
  const initializeSorting = (
    sortingOrders: ComputedRef<Sort[] | SortingOption[]>,
    currentSortingOrder?: ComputedRef<string | undefined>,
  ) => {
    if (initialized) return;

    cachedSortingOptions.value = sortingOrders.value.map(normalizeSortingOption);
    cachedSortingValue.value = currentSortingOrder?.value ?? '';
    initialized = true;
  };

  return {
    initializeSorting,
    initialSortingOptions: cachedSortingOptions,
    initialSortingValue: cachedSortingValue,
    isSortingInitialized: () => initialized,
  };
};
